export default "__VITE_ASSET__6pNT$Efe__"